export default function Proof() {
  const proofBlocks = [
    {
      title: '事例（例：BtoBサービス）',
      text: 'ここに1〜3件。業種 / 課題 / 施策 / 結果（%でもOK）を記載。',
      image: 'https://public.readdy.ai/ai/img_res/b27d8072025436becbdb38662d34a695.jpg'
    },
    {
      title: '事例（例：EC/LP）',
      text: 'ここに1〜3件。改善前の離脱/CTR/CVRなど "どれが動いたか" を記載。',
      image: 'https://readdy.ai/api/search-image?query=E-commerce%20landing%20page%20optimization%20results%20showing%20conversion%20rate%20improvements%20with%20analytics%20dashboard%2C%20clean%20modern%20interface%20displaying%20CTR%20CVR%20metrics%20before%20and%20after%2C%20light%20gray%20and%20white%20color%20scheme%2C%20minimalist%20design%2C%20high%20quality%20digital%20illustration%2C%20professional%20marketing%20analytics%20visualization&width=600&height=400&seq=autopilot-case-002&orientation=landscape'
    },
    {
      title: '改善の考え方（数値で判断）',
      text: 'CTR / 滞在 / CVR を見て「広告の問題か」「LPの問題か」を切り分けます。',
      image: 'https://readdy.ai/api/search-image?query=Marketing%20analytics%20decision%20framework%20diagram%20showing%20CTR%20bounce%20rate%20and%20CVR%20metrics%20analysis%2C%20clean%20modern%20flowchart%20with%20data-driven%20decision%20points%2C%20light%20gray%20and%20white%20color%20scheme%2C%20minimalist%20design%2C%20high%20quality%20digital%20illustration%2C%20professional%20marketing%20strategy%20visualization&width=600&height=400&seq=autopilot-case-003&orientation=landscape'
    }
  ];

  return (
    <section id="proof" className="py-20 md:py-28 bg-gray-50">
      <div className="max-w-[1200px] mx-auto px-6 md:px-8">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-black text-gray-900 mb-4">
            信頼の根拠
          </h2>
          <p className="text-base md:text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            実績が少ない場合でも「プロセス」「改善の例」「Before/Afterの指標」だけは出せます。
          </p>
        </div>

        <div className="space-y-12">
          {proofBlocks.map((block, index) => (
            <div key={index} className={`grid grid-cols-1 lg:grid-cols-2 gap-8 items-center ${
              index % 2 === 1 ? 'lg:flex-row-reverse' : ''
            }`}>
              <div className={`${index % 2 === 1 ? 'lg:order-2' : ''}`}>
                <div className="rounded-xl overflow-hidden shadow-lg">
                  <img
                    src={block.image}
                    alt={block.title}
                    className="w-full h-auto object-cover"
                  />
                </div>
              </div>
              <div className={`${index % 2 === 1 ? 'lg:order-1' : ''}`}>
                <h3 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4">{block.title}</h3>
                <p className="text-base md:text-lg text-gray-600 leading-relaxed">{block.text}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
